import { Routes } from '@angular/router';
import { Home } from './pages/home/home';
import { Article } from './pages/article/article';
import { Press } from './pages/press/press';
import { About } from './pages/about/about';
import { Portfolio } from './pages/portfolio/portfolio';
import { Contact } from './pages/contact/contact';
import { TermsOfUse } from './pages/terms-of-use/terms-of-use';
import { Privacy } from './pages/privacy/privacy';
import { MariPrivacyNotice } from './pages/mari-privacy-notice/mari-privacy-notice';
import { EmployeePrivacyNotice } from './pages/employee-privacy-notice/employee-privacy-notice';
import { HydeParkWinterWonderlandPrivacyNotice } from './pages/hyde-park-winter-wonderland-privacy-notice/hyde-park-winter-wonderland-privacy-notice';
import { MubadalaAbuDhabiOpenPrivacyNotice } from './pages/mubadala-abu-dhabi-open-privacy-notice/mubadala-abu-dhabi-open-privacy-notice';
import { CookiePolicy } from './pages/cookie-policy/cookie-policy';
import { PrivacyNotice } from './pages/privacy-notice/privacy-notice';
import { EventPrivacyNotices } from './pages/event-privacy-notices/event-privacy-notices';
import { SupplierCodeOfConduct } from './pages/supplier-code-of-conduct/supplier-code-of-conduct';

export const routes: Routes = [
  {
    path: '',
    component: Home,
  },
  {
    path: 'about',
    component: About,
  },
  {
    path: 'portfolio',
    component: Portfolio,
  },
  {
    path: 'press',
    component: Press,
  },
  {
    path: 'contact',
    component: Contact,
  },
  {
    path: 'press/:slug',
    component: Article,
  },
  {
    path: 'supplier-code-of-conduct',
    component: SupplierCodeOfConduct,
  },
  {
    path: 'terms-of-use',
    component: TermsOfUse,
  },
  {
    path: 'privacy',
    component: Privacy,
  },
  {
    path: 'mari-privacy-notice',
    component: MariPrivacyNotice,
  },
  {
    path: 'employee-privacy-notice',
    component: EmployeePrivacyNotice,
  },
  {
    path: 'hyde-park-winter-wonderland-privacy-notice',
    component: HydeParkWinterWonderlandPrivacyNotice,
  },
  {
    path: 'mubadala-abu-dhabi-open-privacy-notice',
    component: MubadalaAbuDhabiOpenPrivacyNotice,
  },
  {
    path: 'privacy-policy',
    redirectTo: 'privacy',
    pathMatch: 'full',
  },
  {
    path: 'privacy-notice',
    component: PrivacyNotice,
  },
  {
    path: 'event-privacy-notices',
    component: EventPrivacyNotices,
  },
  {
    path: 'cookie-policy',
    component: CookiePolicy,
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full',
  },
];
